import { api, apiPost } from "@/shared/api/http";
import type { UserOut } from "@/shared/lib/auth-store";

export interface RegisterIn {
  email: string;
  password: string;
}
export interface RegisterOut {
  user_id: string;
  is_approved: boolean;
}
export interface LoginIn {
  email: string;
  password: string;
}
export interface TokenOut {
  token: string;
  token_type: string;
}

export const registerUser = (body: RegisterIn) =>
  apiPost<RegisterOut>("/api/auth/register", body);

export const loginUser = (body: LoginIn) =>
  apiPost<TokenOut>("/api/auth/login", body);

export const fetchMe = () => api<UserOut>("/api/me");
